import { Box, Typography } from "@mui/material";
import axios from "axios";
import Datumizo from "Components/LabIZO/Datumizo/Datumizo";
import { HStack, VStack } from "Components/LabIZO/Stackizo";
import { Accessor, Authority, ColorX, ErrorX, store } from "static";
import _ from "lodash";
import moment from "moment";
import { Component } from "react";
import { DOMAIN } from "config/config";
import TrainCreate from "../Training/TrainCreate";
import ConvlogDetail from "./ConvlogDetail/ConvlogDetail";
import schema from "./schema";
import { DateTimeRangePicker } from "Components/DatePicker/DateTimeRangePicker";
import { DATA_LINK, backendConnector } from "connectors";

class Convlog extends Component {
  static propTypes = {};

  static defaultProps = {};

  constructor() {
    super();
    this.state = {
      intents: [],
      title: "CONVERSATION OVERVIEW",
      period: { DateRange: [moment().startOf("month"), moment().endOf("month")] },
      serverSidePagination: true,
      base: {
        title: "Convlog",
        exportDoc: "Convlog",
        schema: schema,
        reqAuth: "Convlog",

        tablizo: {
          showSelector: true,
          columnsToolbar: true,
          filterToolbar: true,
          densityToolbar: true,
          exportToolbar: false,
        },

        Connect: {
          DBInfo: DATA_LINK.ConvlogDBInfo,
          List: DATA_LINK.ConvlogList,
          SetColumnVisibilitySetting: DATA_LINK.ConvlogSetColumnVisibilitySetting,
          schema: schema.Table,
        },

        operations: {
          List: {
            addOnsOverride: (addOns) => {
              const newAddOns = _.cloneDeep(addOns);
              delete newAddOns.intents;
              return newAddOns;
            },
          },

          Export: {
            url: DATA_LINK.ConvlogExport,
            schema: schema.Export,
          },

          Info: {
            title: "CONVERSATION DETAILS",
            success: "Convlog Load Successfully",
            fail: "Convlog Load Failed: ",
            schema: schema.Info,
            readOnly: true,
            Custom: (id, doc, onQuit, onQuitRefresh, renderFormizo, addOns) => {
              return <ConvlogDetail id={id} doc={doc} intents={addOns.intents} period={this.state.period} />;
            },
          },

          Training: {
            title: "Initiate Training",
            Custom: (id, row, onQuit, onQuitRefresh, renderFormizo, addOns) => {
              return <TrainCreate onQuit={onQuit} DateRange={addOns.DateRange} />;
            },
          },
        },

        buttons: {
          inline: [{ icon: "info", func: "Info", reqFunc: "Info", caption: "Details" }],
          right: [
            { icon: "export", func: "Export", caption: (n) => "Export (" + (n === 0 ? "All" : n) + ")", reqFunc: "Export" },
            {
              icon: "initTrain",
              func: this._initTraining,
              caption: "Initiate Training",
              reqFunc: "InitTrain",
              theme: {
                label: "white",
                background: ColorX.GetColorCSS("Decorate1"),
                hover: {
                  background: "#115293",
                },
              },
            },
          ],
        },
      },
    };
  }

  componentDidMount() {
    Authority.Require("Convlog");
    this._setAllStates(() => {
      this.getAllIntents();
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (!Accessor.IsIdentical(prevProps, this.props, Object.keys(Convlog.defaultProps))) {
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  getAllIntents = async () => {
    let url = DOMAIN + "/Tables/Intent/List";
    let payload = {
      JWT: store.user.JWT,
      data: {
        skip: 0,
        limit: 9999,
        fields: ["_id", "Description"],
      },
      addOns: {
        workspace: "ALL",
        allIntents: true,
      },
      skipAudit: true,
    };
    try {
      const { Success, payload } = await backendConnector.post(
        DATA_LINK.IntentList,
        {
          skip: 0,
          limit: 9999,
          fields: ["_id", "Description"],
        },
        {
          workspace: "ALL",
          allIntents: true,
        }
      );
      if (Success === true) {
        let docs = payload.docs;
        let intents = _.map(docs, (o, i) => {
          let splited = o._id.split(":");
          let caption = o._id;
          if (splited.length === 2) {
            caption = splited[1];
          }
          return {
            _id: o._id,
            caption: caption,
            Description: o.Description,
          };
        });
        this.setState((state, props) => ({
          intents: intents,
        }));
      } else {
        ErrorX.Handle(payload.message || "");
      }
    } catch (e) {
      ErrorX.Handle(e);
    }
  };

  _setAllStates = (callback) => {
    this.setState(
      (state, props) => ({
        ...props,
      }),
      callback
    );
  };

  onMountDatumizo = (callbacks) => {
    this.MountDatumizo = callbacks;
  };

  _initTraining = () => {
    console.log("init training");
    this.MountDatumizo.CustomInner("Training");
  };

  datePickerCallback = (dates) => {
    if (Array.isArray(dates) && dates.length == 2) {
      this.setState(() => ({
        period: {
          DateRange: dates,
        },
      }));
    }
  };

  renderDatePicker = () => {
    const { period } = this.state;
    const handleDateChange = (newDates) => {
      if (newDates && newDates[0] && newDates[1]) {
        this.setState((state) => {
          return {
            period: {
              ...state.period,
              DateRange: newDates,
            },
            base: {
              ...state.base,
              exportDoc: `Convlog_${newDates[0].format("YYYYMMDD")}_${newDates[1].format("YYYYMMDD")}`,
            },
          };
        });
        this.MountDatumizo.Reload();
      }
      store.setFilterSettingDateRange(newDates, "Convlog");
    };

    return (
      <DateTimeRangePicker
        dates={period.DateRange}
        onChangeDates={handleDateChange}
        limitSelectedPeriod={{ unit: "years", value: 1 }}
        helperText="Select date range to filter the data. You may select up to 1 year's data."
      />
    );
  };

  getDoc = (docID, field) => {
    return this.MountDatumizo.GetDoc(docID, field);
  };

  renderTable = () => {
    const { base, serverSidePagination, period, intents } = this.state;
    return (
      <Datumizo
        base={base}
        addOns={{
          ...period,
          getDoc: this.getDoc,
          intents,
          otherintents: Authority.IsAccessibleQ("Convlog", undefined, "NlpInfo") ? 4 : 0,
        }}
        serverSidePagination={serverSidePagination}
        onMounted={this.onMountDatumizo}
        languageSelector={false}
        datePickerCallback={this.datePickerCallback}
      />
    );
  };

  render() {
    let { title } = this.state;
    return (
      <VStack>
        <Box padding={1} width="100%">
          <HStack
            justifyContent="flex-start"
            gap={8}
            style={{
              display: "flex",
              width: "100%",
            }}
          >
            <Typography
              style={{
                alignItems: "left",
                display: "flex",
                fontSize: 25,
                color: ColorX.GetColorCSS("Primary"),
              }}
            >
              {title}
            </Typography>
            {this.renderDatePicker()}
          </HStack>
        </Box>

        {this.renderTable()}
      </VStack>
    );
  }
}

export default Convlog;
